import type { GetExploreContent200PageAllOfThreeContentItemAuth } from './getExploreContent200PageAllOfThreeContentItemAuth';
import type { GetExploreContent200PageAllOfThreeContentItemBasicInfo } from './getExploreContent200PageAllOfThreeContentItemBasicInfo';
import type { GetExploreContent200PageAllOfThreeContentItemContent } from './getExploreContent200PageAllOfThreeContentItemContent';

export type GetExploreContent200PageAllOfThreeContentItem = {
  /** 인증 컨텍스트 정보 */
  auth?: GetExploreContent200PageAllOfThreeContentItemAuth;
  basicInfo?: GetExploreContent200PageAllOfThreeContentItemBasicInfo;
  /** 콘텐츠 데이터 (타입에 따라 다른 형식) */
  content?: GetExploreContent200PageAllOfThreeContentItemContent;
};
